import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { LanguageService } from '../../../core/service/language.service';
import { LettingFeatureReferenceType } from '../../model/letting-feature';

@Component({
  selector: 'app-letting-feature-column',
  template: `{{ value }}`,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LettingFeatureColumnComponent {
  value = '';

  constructor(private readonly languageService: LanguageService) {}

  @Input() set dataContext(referenceTypes: number[] | null | undefined) {
    const values = referenceTypes ?? [];
    const captions = [
      values.includes(LettingFeatureReferenceType.Included) ? this.languageService.instant('RENTAL_OBJECT.LETTING_FEATURES.INCLUDED') : null,
      values.includes(LettingFeatureReferenceType.NotIncluded) ? this.languageService.instant('LETTING_FEATURE.FILTER_NOT_INCLUDED') : null,
    ].filter(value => !!value);

    this.value = captions.join(', ');
  }
}
